import React, { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import AnalyticsConsent, { ANALYTICS_SETTINGS_EVENT } from './components/AnalyticsConsent';
import PortfolioRefreshListener from './components/PortfolioRefreshListener';
import Home2 from './pages/Home2';
import Resume from './pages/Resume';
import Work from './pages/Work';

const Manage = lazy(() => import('./pages/Manage'));

function App() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <PortfolioRefreshListener />
      <AnalyticsConsent />
      <div className="app-container flex min-h-[100dvh] flex-col">
        <Header />

        <main className="flex flex-1 flex-col">
          <Routes>
            <Route path="/" element={<Home2 />} />
            <Route path="/from/:source" element={<Home2 />} />
            <Route path="/resume" element={<Resume />} />
            <Route path="/work" element={<Work />} />
            <Route
              path="/manage"
              element={
                <Suspense fallback={<p className="py-20 text-center text-muted">Loading…</p>}>
                  <Manage />
                </Suspense>
              }
            />
            <Route path="*" element={<Home2 />} />
          </Routes>
        </main>

        <footer className="flex-none border-t border-line py-4 sm:py-7">
          <div className="container-shell flex flex-col gap-2 font-mono text-[10px] uppercase tracking-[0.1em] text-muted sm:flex-row sm:items-center sm:justify-between">
            <p>© {new Date().getFullYear()} Baba Hadj Said</p>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
              <p>Built as a living system · Genova, IT</p>
              <button
                className="uppercase tracking-[0.1em] text-muted underline-offset-4 transition hover:text-accent hover:underline"
                onClick={() => window.dispatchEvent(new Event(ANALYTICS_SETTINGS_EVENT))}
                type="button"
              >
                Analytics settings
              </button>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
